import { useState, useEffect } from 'react';
import { getCookie } from '@/app/utils/client-cookies';
import { CookiesEnum } from '@/app/enums/Cookies';
import { PRETTO_UTM_PARAMS, PrettoUtmContext } from '@/app/constants/prettoJourney';
import { appendPrettoUtmContext } from '@/app/utils/pretto-url';
import { AFFILIATED_LINK } from '../utils';

// UTMs en tête pour matcher le déclencheur de conversion Session côté Pretto (GTM)
function buildAffiliatedLink(utm: PrettoUtmContext, userToken?: string | null, gclid?: string | null): string {
  const params = new URLSearchParams({ ...PRETTO_UTM_PARAMS });
  appendPrettoUtmContext(params, utm);
  if (userToken) {
    params.set('user_token', userToken);
  }
  if (gclid) {
    params.set('gclid', gclid);
  }
  return `${AFFILIATED_LINK}?${params.toString()}`;
}

export function useAffiliatedLink(isVariant: boolean, {content, term}: PrettoUtmContext) {
  const [linkHref, setLinkHref] = useState(buildAffiliatedLink({content, term}));

  useEffect(() => {
    const userToken = getCookie(CookiesEnum.USER_TRACKING_TOKEN);
    const gclid = getCookie(CookiesEnum.USER_GCLID);
    setLinkHref(buildAffiliatedLink({content, term}, userToken, gclid));
  }, [content, term]);

  return linkHref;
}
